import { APP_PATHS } from 'app-shared/constants';

// Clerk's workspace screen opens on its general page (name, leave, delete);
// this is the path of its members page, below our members settings page.
export const CLERK_MEMBERS_PAGE_PATH = `${APP_PATHS.settingsMembers}/organization-members`;
